import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SignWordSearch } from "../../components/SignWordSearch";

const searchSchema = z.object({
  q: z.string().optional(),
});

export const Route = createFileRoute("/_app/sign-words")({
  component: SignWordsPage,
  validateSearch: searchSchema,
});

function SignWordsPage() {
  const { q } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">手話単語検索</h1>
        <p className="text-sm text-neutral-600 mt-1">
          ことばを打つと、その手話がすぐ見られます
        </p>
      </div>
      <SignWordSearch
        initialQuery={q ?? ""}
        // 履歴を増やさず URL の検索語だけ書き換える。再生画面から戻ったときに復元される
        onQueryChange={(value) =>
          navigate({ search: { q: value || undefined }, replace: true })
        }
      />
    </div>
  );
}
